<template>
  <section class="a-cover header-padding">
    <div class="r-cover">
      <Map class="z-0" />
    </div>
  </section>
</template>

<script>
import Map from '@/components/Map.vue'

export default {
  name: 'Campus',

  components: {
    Map
  }
}
</script>
